export const BUSINESS_NAME = "HapiColibri";
export const SLOGAN = "Partageons la Vie";
export const APP_NAME = "HapiColibri";
export const APP_BUNDLE_ID = "com.digihapi.hapicolibri";
// Sign in with Apple (web). APPLE_WEB_SERVICE_ID is the Apple "Services ID"
// (the web client_id). The redirect URI is derived at runtime from the current
// origin (see services/appleWebAuth.js) so it works on both staging
// (https://staging.app.hapicolibri.digihapi.com/) and production
// (https://app.hapicolibri.digihapi.com/) — BOTH must be registered as Return
// URLs for this Services ID in the Apple Developer portal. Set
// APPLE_WEB_REDIRECT_URI only to force a fixed value (otherwise leave empty).
export const APPLE_WEB_SERVICE_ID = "com.digihapi";
export const APPLE_WEB_REDIRECT_URI = "";
// Sign in with Google (web). OAuth 2.0 "Web" client ID (Google Cloud Console),
// used by the Google Identity Services auth-code popup; the server exchanges the
// returned code (redirect_uri "postmessage"). The web app's origin(s) must be
// registered as Authorized JavaScript origins for this client. Set
// EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID at build time, or hardcode the value here.
export const GOOGLE_WEB_CLIENT_ID =
	process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID || "";
// Login with Facebook (web). Facebook App ID — public (not the App Secret).
export const FACEBOOK_APP_ID =
	process.env.EXPO_PUBLIC_FACEBOOK_APP_ID || "996736649450398";
export const COMMUNITY = "neighborhood";
export const COMMUNITIES = "neighborhoods";
export const UUID_NAMESPACE = "5d95fcc9-733b-48ba-8713-3fba0777d2fd";
export const PROTOCOL = "hapicolibri";

export const WEB_URL = "www.hapicolibri.fr";
export const DEEPLINK_APP_URL = "https://app.hapicolibri.fr";
export const DEEPLINK_URL_SCHEME = PROTOCOL + "://";
export const PWA_DEEPLINK_APP_URL =
	"https://staging.app.hapicolibri.digihapi.com";
export const CONTACT_MAIL = "contact.digihapi@gmail.com";
export const URL_PREFIX = "";

export const NOTIFICATION_ANDROID_CHANNEL_NAME = APP_NAME;

export const GOOGLE_CLOUD_STORAGE_URL =
	"https://storage.googleapis.com/digihapi/OCamping";

export const CREATE_COMMUNITY_URL =
	"https://www.hapicolibri.fr/enregistrement-voisinage";
export const APPLE_STORE_URL =
	"http://itunes.apple.com/fr/app/hapicolibri/id1507233341?mt=8";
export const GOOGLE_PLAY_URL =
	"https://play.google.com/store/apps/details?id=com.digihapi.hapicolibri.app";

export const NEIGHBORHOOD_MARKER =
	"https://mt.google.com/vt/icon/name=icons/spotlight/home_L_8x.png&scale=2";
export const ORGANIZATION_MARKER =
	"https://mt.google.com/vt/icon/name=icons/spotlight/worship_dharma_search_L_8x.png&scale=2";

export const TYPE_ACTIVITY = "Activity";
export const TYPE_PROPOSAL = "Proposal";
export const TYPE_TEMPLATE = "Template";

export const ROLE_GUEST = "Guest";
export const ROLE_ADVERTISER = "Advertiser";
export const ROLE_NEIGHBOR = "Neighbor";
export const ROLE_NEIGHBOR_GUEST = "Neighbor guest";
export const ROLE_EMPLOYEE = "Employee";
export const ROLE_EMPLOYEE_GUEST = "Employee guest";
export const ROLE_ADMINISTRATOR = "Administrator";
export const ROLE_WEBMASTER = "Webmaster";
export const ROLE_ADVERTISER_GUEST = "Advertiser guest";

export const GROUP_ID_WEATHER = "weather";
export const GROUP_ID_ACTIVITY = "activity";
export const GROUP_ID_GOODDEAL_ACTIVITY = "gooddealactivity";
export const GROUP_ID_PROPOSAL = "proposal";
export const GROUP_ID_TEMPLATE = "template";
export const GROUP_ID_PUBLISH = "publish";
export const GROUP_ID_NEW_USER = "newUser";

export const EVENT_PING = "ping";

// Navigation routes
export const ABOUT_ROUTE = "a-propos";
export const CITIES_ROUTE = "villes";
export const COMMUNITIES_MAPS_ROUTE = "carte-communautes";
export const COMMUNITIES_ROUTE = "communautes";
export const AD_ROUTE = "annonce";
export const MAINTENANCE_ROUTE = "maintenance";
export const CGU_ROUTE = "conditions-generales-utilisation";
export const LOCAL_LIFE_ROUTE = "vie-locale";
export const EVENT_DETAILS_ROUTE = "publication";

export const NEWS_FEED_ROUTE = "actualite";
export const MY_CONVERSATIONS_ROUTE = "mes-conversations";
export const MY_PROFILE_ROUTE = "mon-profil";
export const CAMERA_ROUTE = "appareil-photo";
export const PROFILE_ROUTE = "profil";
export const ZOOM_IMAGE_ROUTE = "zoom-image";
export const YOUTUBE_ROUTE = "youtube";

export const REGISTER_ROUTE = "enregistrement";

export const LANDING_ROUTES = new Set([
	ABOUT_ROUTE,
	CITIES_ROUTE,
	COMMUNITIES_MAPS_ROUTE,
	COMMUNITIES_ROUTE,
	MAINTENANCE_ROUTE,
	CGU_ROUTE,
	LOCAL_LIFE_ROUTE,
	ZOOM_IMAGE_ROUTE,
	EVENT_DETAILS_ROUTE
]);

export const AUTHENTICATED_ROUTES = new Set([
	MY_CONVERSATIONS_ROUTE,
	MY_PROFILE_ROUTE,
	PROFILE_ROUTE,
	CAMERA_ROUTE,
	ZOOM_IMAGE_ROUTE,
	YOUTUBE_ROUTE,
	LOCAL_LIFE_ROUTE,
	AD_ROUTE,
	ABOUT_ROUTE,
	MAINTENANCE_ROUTE
]);

// Routes only available to logged in users: the login is proposed first,
// then the route is opened
export const LOGIN_REQUIRED_ROUTES = new Set([AD_ROUTE]);

export const REGISTER_ROUTES = new Set([REGISTER_ROUTE]);
export const ALL_ROUTES = new Set([
	...LANDING_ROUTES,
	...AUTHENTICATED_ROUTES,
	...REGISTER_ROUTES
]);

// AsyncStorage key of the community selected by the user (url, list, map,
// qr-code or session), proposed again on the next launch
export const SELECTED_COMMUNITY_URI_KEY = "selectedCommunityUri";

// Initial center [longitude, latitude] of the communities map when no
// community is selected yet (Annecy)
export const DEFAULT_MAP_COORDINATES = [6.1294, 45.8992];
